import { enableProdMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { createAppInstance } from '@mbs-ui/app/app.module';
import { loadConfigurations } from 'mbs-ui-shared';

if (environment.production) {
  enableProdMode();
}

function mountApp(config) {
  createAppInstance(config)
    .then((application) => {
      if (!environment.production) {
        const appComponent = application.components[0];
        enableDebugTools(appComponent);
      }
    })
    .catch((err) => console.error(err));
}

loadConfigurations(environment.production ? 'assets/config/config.json' : 'config/config.json')
  .then((res: string) => {
    try {
      mountApp(JSON.parse(res));
    } catch (err) {
      console.error(err);
    }
  })
  .catch((err) => console.error(err.message));
